import Footer from "./Footer";
import Header from "./Header";

const CommonLayout = (props) => {
  return (
    <>
 
      <Header />
      {props.children}
      <Footer />
 
    </>
  );
};

export default CommonLayout;
